module.exports = __webpack_public_path__ + "img/cbd-desktop-inactive.1af63d2.svg";